import { Divider, Typography } from "@material-ui/core";
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setOpenDialog } from "../../store/appSlice";
import { IReduxState } from "../../store"
import AddIcon from '@mui/icons-material/Add';



export interface IMyDialogComponentProps {
    dialogTitle?: string;
    dialogContent?: any;
    handleSave?: any;
    openDialog: boolean;
    handleClose?: any
    handleOpen?: any
    hidButton?: boolean
}



const MyDialogComponent = (props: IMyDialogComponentProps) => {

    const {
        dialogTitle,
        dialogContent,
        handleSave,
        openDialog,
        handleClose,
        handleOpen,
        hidButton
    } = props

    //redux
    // const { openDialog } = useSelector((state: IReduxState) => state.application);
    const dispatch = useDispatch()




    return (
        <div>
            {!hidButton &&
                <Button
                    onClick={() => { handleOpen() }}
                >
                    <AddIcon />
                </Button>}
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    <Typography variant="body2">
                        {dialogTitle}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {dialogContent}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={handleClose} color="error">Fermer</Button>
                    <Button onClick={handleSave} color="primary">Enregistrer</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default MyDialogComponent;
